module.exports = __webpack_public_path__ + "static/media/coinbase.d67d5c53.png";